import styled from 'styled-components';
import { VideoLastPublish } from '../../types.ts/story';

type Props = {
  lastPublishInfo: VideoLastPublish[];
  displayWhenEmpty?: boolean;
  displayPublishInfoInNewline?: boolean;
};

const LastPublishedInfo = ({
  lastPublishInfo,
  displayWhenEmpty = true,
  displayPublishInfoInNewline = false,
}: Props) => {
  if (displayWhenEmpty && !lastPublishInfo.length) return <PublishInfo />;

  if (!lastPublishInfo.length) return null;

  const mostRecent = lastPublishInfo.reduce((latest, current) =>
    !latest || new Date(current.timestamp) > new Date(latest.timestamp)
      ? current
      : latest,
  );

  const formattedDateTime = new Date(mostRecent.timestamp).toLocaleString(
    'en-US',
    {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    },
  );

  const resolutionInfo = mostRecent.resolution
    ? ` in ${mostRecent.resolution}`
    : '';

  const publishInfo = `by ${mostRecent.publisher}${resolutionInfo}`;

  return (
    <PublishInfo>
      Last published on {formattedDateTime}
      {displayPublishInfoInNewline ? `\n${publishInfo}` : ` ${publishInfo}`}
    </PublishInfo>
  );
};

export default LastPublishedInfo;

const PublishInfo = styled.div`
  font-size: 10px;
  color: #848484;
  font-style: italic;
  font-weight: 300;
  line-height: 13px;
  white-space: pre-line;
`;
